<template>
  <div>
   <back-btn/>

    <v-row justify="center">
      <v-col cols="12" md="6">
        <pa-form @emitPaData="createPA" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PaForm from "@/components/pa/PaForm";
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    PaForm,
    BackBtn,
  },
  data: () => ({
  }),
  methods: {
    createPA(payload) {
      console.log(payload);
      this.$store.dispatch("Pa/createPA", payload).then(() => {
        this.$router.push("/pa");
      });
    },
  },
};
</script>
